/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.auth
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/auth/user_profile.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var protoc$gen$openapiv2_options_annotations_pb = require("../../../protoc-gen-openapiv2/options/annotations_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.auth = require("./user_profile_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.auth.UserProfileServiceClient =
  function UserProfileServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient =
  function UserProfileServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.auth.AuthenticateUserRequest,
 *   !proto.stronachgroup.first.auth.AuthenticateUserResponse>}
 */
const methodDescriptor_UserProfileService_AuthenticateUser =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/AuthenticateUser",
    grpc.web.MethodType.UNARY,
    proto.stronachgroup.first.auth.AuthenticateUserRequest,
    proto.stronachgroup.first.auth.AuthenticateUserResponse,
    /**
     * @param {!proto.stronachgroup.first.auth.AuthenticateUserRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    proto.stronachgroup.first.auth.AuthenticateUserResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.auth.AuthenticateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.auth.AuthenticateUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.auth.AuthenticateUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.auth.UserProfileServiceClient.prototype.authenticateUser =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/AuthenticateUser",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_AuthenticateUser,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.auth.AuthenticateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.auth.AuthenticateUserResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient.prototype.authenticateUser =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/AuthenticateUser",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_AuthenticateUser
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.auth.AuthenticatePinUserRequest,
 *   !proto.stronachgroup.first.auth.AuthenticatePinUserResponse>}
 */
const methodDescriptor_UserProfileService_AuthenticatePinUser =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/AuthenticatePinUser",
    grpc.web.MethodType.UNARY,
    proto.stronachgroup.first.auth.AuthenticatePinUserRequest,
    proto.stronachgroup.first.auth.AuthenticatePinUserResponse,
    /**
     * @param {!proto.stronachgroup.first.auth.AuthenticatePinUserRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    proto.stronachgroup.first.auth.AuthenticatePinUserResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.auth.AuthenticatePinUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.auth.AuthenticatePinUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.auth.AuthenticatePinUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.auth.UserProfileServiceClient.prototype.authenticatePinUser =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/AuthenticatePinUser",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_AuthenticatePinUser,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.auth.AuthenticatePinUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.auth.AuthenticatePinUserResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient.prototype.authenticatePinUser =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/AuthenticatePinUser",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_AuthenticatePinUser
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.auth.GetUserByUsernameRequest,
 *   !proto.stronachgroup.first.auth.GetUserByUsernameResponse>}
 */
const methodDescriptor_UserProfileService_GetUserByUsername =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/GetUserByUsername",
    grpc.web.MethodType.UNARY,
    proto.stronachgroup.first.auth.GetUserByUsernameRequest,
    proto.stronachgroup.first.auth.GetUserByUsernameResponse,
    /**
     * @param {!proto.stronachgroup.first.auth.GetUserByUsernameRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    proto.stronachgroup.first.auth.GetUserByUsernameResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.auth.GetUserByUsernameRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.auth.GetUserByUsernameResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.auth.GetUserByUsernameResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.auth.UserProfileServiceClient.prototype.getUserByUsername =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetUserByUsername",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_GetUserByUsername,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.auth.GetUserByUsernameRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.auth.GetUserByUsernameResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient.prototype.getUserByUsername =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetUserByUsername",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_GetUserByUsername
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.auth.GetUserInfoRequest,
 *   !proto.stronachgroup.first.auth.GetUserInfoResponse>}
 */
const methodDescriptor_UserProfileService_GetUserInfo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/GetUserInfo",
    grpc.web.MethodType.UNARY,
    proto.stronachgroup.first.auth.GetUserInfoRequest,
    proto.stronachgroup.first.auth.GetUserInfoResponse,
    /**
     * @param {!proto.stronachgroup.first.auth.GetUserInfoRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    proto.stronachgroup.first.auth.GetUserInfoResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.auth.GetUserInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.auth.GetUserInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.auth.GetUserInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.auth.UserProfileServiceClient.prototype.getUserInfo =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetUserInfo",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_GetUserInfo,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.auth.GetUserInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.auth.GetUserInfoResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient.prototype.getUserInfo =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetUserInfo",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_GetUserInfo
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.auth.FirebaseTokenRequest,
 *   !proto.stronachgroup.first.auth.FirebaseTokenResponse>}
 */
const methodDescriptor_UserProfileService_GetFirebaseToken =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/GetFirebaseToken",
    grpc.web.MethodType.UNARY,
    proto.stronachgroup.first.auth.FirebaseTokenRequest,
    proto.stronachgroup.first.auth.FirebaseTokenResponse,
    /**
     * @param {!proto.stronachgroup.first.auth.FirebaseTokenRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    proto.stronachgroup.first.auth.FirebaseTokenResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.auth.FirebaseTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.auth.FirebaseTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.auth.FirebaseTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.auth.UserProfileServiceClient.prototype.getFirebaseToken =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetFirebaseToken",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_GetFirebaseToken,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.auth.FirebaseTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.auth.FirebaseTokenResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient.prototype.getFirebaseToken =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetFirebaseToken",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_GetFirebaseToken
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.auth.UnlinkIdentityRequest,
 *   !proto.stronachgroup.first.auth.UnlinkIdentityResponse>}
 */
const methodDescriptor_UserProfileService_UnlinkIdentity =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/UnlinkIdentity",
    grpc.web.MethodType.UNARY,
    proto.stronachgroup.first.auth.UnlinkIdentityRequest,
    proto.stronachgroup.first.auth.UnlinkIdentityResponse,
    /**
     * @param {!proto.stronachgroup.first.auth.UnlinkIdentityRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    proto.stronachgroup.first.auth.UnlinkIdentityResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.auth.UnlinkIdentityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.auth.UnlinkIdentityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.auth.UnlinkIdentityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.auth.UserProfileServiceClient.prototype.unlinkIdentity =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/UnlinkIdentity",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_UnlinkIdentity,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.auth.UnlinkIdentityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.auth.UnlinkIdentityResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient.prototype.unlinkIdentity =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/UnlinkIdentity",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_UnlinkIdentity
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest,
 *   !proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse>}
 */
const methodDescriptor_UserProfileService_UpdateUser1stbetPreferences =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/UpdateUser1stbetPreferences",
    grpc.web.MethodType.UNARY,
    proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest,
    proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse,
    /**
     * @param {!proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.auth.UserProfileServiceClient.prototype.updateUser1stbetPreferences =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/UpdateUser1stbetPreferences",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_UpdateUser1stbetPreferences,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient.prototype.updateUser1stbetPreferences =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/UpdateUser1stbetPreferences",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_UpdateUser1stbetPreferences
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.auth.ClearUser1stbetPreferencesRequest,
 *   !proto.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse>}
 */
const methodDescriptor_UserProfileService_ClearUser1stbetPreferences =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/ClearUser1stbetPreferences",
    grpc.web.MethodType.UNARY,
    proto.stronachgroup.first.auth.ClearUser1stbetPreferencesRequest,
    proto.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse,
    /**
     * @param {!proto.stronachgroup.first.auth.ClearUser1stbetPreferencesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    proto.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.auth.ClearUser1stbetPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.auth.UserProfileServiceClient.prototype.clearUser1stbetPreferences =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/ClearUser1stbetPreferences",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_ClearUser1stbetPreferences,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.auth.ClearUser1stbetPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient.prototype.clearUser1stbetPreferences =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/ClearUser1stbetPreferences",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_ClearUser1stbetPreferences
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.auth.GetAccountInfoRequest,
 *   !proto.stronachgroup.first.auth.GetAccountInfoResponse>}
 */
const methodDescriptor_UserProfileService_GetAccountInfo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/GetAccountInfo",
    grpc.web.MethodType.UNARY,
    proto.stronachgroup.first.auth.GetAccountInfoRequest,
    proto.stronachgroup.first.auth.GetAccountInfoResponse,
    /**
     * @param {!proto.stronachgroup.first.auth.GetAccountInfoRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    proto.stronachgroup.first.auth.GetAccountInfoResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.auth.GetAccountInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.auth.GetAccountInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.auth.GetAccountInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.auth.UserProfileServiceClient.prototype.getAccountInfo =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetAccountInfo",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_GetAccountInfo,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.auth.GetAccountInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.auth.GetAccountInfoResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient.prototype.getAccountInfo =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetAccountInfo",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_GetAccountInfo
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.auth.UpdateAccountRequest,
 *   !proto.stronachgroup.first.auth.UpdateAccountResponse>}
 */
const methodDescriptor_UserProfileService_UpdateAccount =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/UpdateAccount",
    grpc.web.MethodType.UNARY,
    proto.stronachgroup.first.auth.UpdateAccountRequest,
    proto.stronachgroup.first.auth.UpdateAccountResponse,
    /**
     * @param {!proto.stronachgroup.first.auth.UpdateAccountRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    proto.stronachgroup.first.auth.UpdateAccountResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.auth.UpdateAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.auth.UpdateAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.auth.UpdateAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.auth.UserProfileServiceClient.prototype.updateAccount =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/UpdateAccount",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_UpdateAccount,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.auth.UpdateAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.auth.UpdateAccountResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.auth.UserProfileServicePromiseClient.prototype.updateAccount =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/UpdateAccount",
      request,
      metadata || {},
      methodDescriptor_UserProfileService_UpdateAccount
    );
  };

module.exports = proto.stronachgroup.first.auth;
